export const banner = (year: string) => {
  return `/${year}/banner`;
};

export const nrSharesSwitzerland = (year: string) => {
  return `/${year}/nr/shares`;
};

export const nrSharesCanton = (year: string, cantonId: string) => {
  return `/${year}/nr/${cantonId}/shares`;
};

export const nrSeatsSwitzerland = (year: string) => {
  return `/${year}/nr/seats`;
};

export const nrSeatsCanton = (year: string, cantonId: string) => {
  return `/${year}/nr/${cantonId}/seats`;
};

export const srCanton = (year: string, cantonId: string) => {
  return `/${year}/sr/${cantonId}`;
};

export const srCountry = (year: string) => {
  return `/${year}/sr`;
};